{
    "favorites": [
        "Knock knock? Whos there? CIA. CIA who? C, I Ate a whole cake!",
        "My Grandma Doris been staring through the window ever since it started to snow... If it gets any worse I'll have to let her in.",
        "What's the worst thing to hear during open heart surgery? Anything!"
    ],
    "general": [
        "Why couldn't Spock flush the toilet? Because of the captain's log",
        "What did the football coach say to the broken vending machine? Give me my quarterback",
        "When is a car not a car? When it turns into parking lot",
        "Where do armies belong? In their sleevies",
        "How do trees get online? They just log on!",
        "What did the pirate say when he turned 80? Aye matey.",
        "What's the difference between a nightwatchman and a butcher? One stays awake and the other weighs a steak",
        "Why did the blind man fall down the well? Because he couldn't see that well.",
        "I tossed a coin in the air and told my friend to call it. He said \"come here, quarter\"!!",
        "Why can't you hear a pterodactyl go to the bathroom? Because the \"P\" is silent.",
        "I asked my german friend if he knew what 3x3 was.. He said nein!"
    ],
    "animal": [
        "What did the buffalo say to her son on the first day of school? Bi son",
        "What do you call a bee born in Spring? A maybe",
        "What do you call a chicken that haunts a house? A poultrygeist",
        "What do you call a pony with a cough? A little horse",
        "What do you call a cow with no legs? Ground beef. What do you call a cow with 3 legs? Lean beef. What do you call a cow with 2 legs? Your mom.",
        "What do you call a deer with no eyes? No ideeer",
        "What do you call a deer with no eyes and no legs? Still no ideer",
        "What do you call a deer with no eyes and no legs in the ocean? Bob",
        "What do you call a fish with no eyes? Fsh",
        "Why did the scarecrow win an award? Because he was outstanding in his field.",
        "What do you get if you cross a rabbit with a wig? Hare"
    ],
    "scary": [
        "What room can't a ghost go into? The Living Room",
        "Why couldn't the skeleton ask someone out on a date? He didn't have the guts",
        "How does a greek god talk to their friend? They column up on the perse-phone",
        "How do you make a tissue dance? You put a little boogie in it",
        "Did you hear about the elevator operator who rode to the basement to pick up dracula? He went down for the Count",
        "What's a ghost's favorite food? Boo-berries"
    ],
    "more": [

    ]
}